import { create } from "zustand";
import { UserStatus } from '@/context/status-context/status-context.tsx';

/**
 * Global status store
 * UserStatusProvider idempotent (so multiple instances don’t fight).
 * One trick: keep the state in a global store (zustand, redux, or even a simple module variable + context).
 */
export const useUserStatusStore = create<{
  status: UserStatus;
  description: string;
  updatedAt: Date;
  setStatus: (s: UserStatus) => void;
  setDescription: (d: string) => void;
  setUpdatedAt: (updatedAt: Date) => void;
}>((set) => ({
  status: "online",
  description: "",
  updatedAt: new Date(),
  setStatus: (s) => set({ status: s, updatedAt: new Date() }),
  setDescription: (d) => set({ description: d }),
  setUpdatedAt: (updatedAt: Date) => set({ updatedAt: updatedAt }),
}));
